// @ts-nocheck
import {
    OrderDetailsRequestedDateStyles,
    requestedDateStyles,
} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsRequestedDate";
import { infoProps } from "@store/Themes/common/props/info";

Object.assign<OrderDetailsRequestedDateStyles>(requestedDateStyles, {
    titleText: infoProps.label,
    description: infoProps.value,
});
